import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ComponentFactoryResolver, Type } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from '@luggagehero/core';
import {
  ExplainStorageTimerActionBaseComponent,
  ManageBookingTimelineBaseComponent,
} from '@luggagehero/features/bookings';
import { SharedAnalyticsService } from '@luggagehero/shared/services/analytics';
import { SharedBookingService } from '@luggagehero/shared/services/bookings';
import { SharedDocumentService } from '@luggagehero/shared/services/document';
import { SharedGoogleMapsService } from '@luggagehero/shared/services/google-maps';
import { SharedLocationService } from '@luggagehero/shared/services/locations';
import { SharedNotificationService } from '@luggagehero/shared/services/notification';
import { SharedReviewsService } from '@luggagehero/shared/services/reviews';
import { SharedShopsService } from '@luggagehero/shared/services/shops';
import { SharedStorageService } from '@luggagehero/shared/services/storage';
import { SharedWindowService } from '@luggagehero/shared/services/window';
import { TranslateService } from '@ngx-translate/core';

import {
  DropOffActionComponent,
  ExplainStorageTimerActionComponent,
  ExploreExperiencesActionComponent,
  GoToShopActionComponent,
  LeaveFeedbackActionComponent,
  ModifyBookingActionComponent,
  SelectPaymentMethodActionComponent,
  ShowReceiptActionComponent,
  UndoDropOffActionComponent,
} from '../booking-actions';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ADMIN_LEVEL = 5;

@Component({
  selector: 'lh-manage-booking-timeline',
  templateUrl: './manage-booking-timeline.component.html',
  styleUrls: ['./manage-booking-timeline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageBookingTimelineComponent extends ManageBookingTimelineBaseComponent {
  constructor(
    modalService: ModalService,
    storageService: SharedStorageService,
    documentService: SharedDocumentService,
    bookingService: SharedBookingService,
    shopsService: SharedShopsService,
    reviewsService: SharedReviewsService,
    locationService: SharedLocationService,
    googleMapsService: SharedGoogleMapsService,
    windowService: SharedWindowService,
    route: ActivatedRoute,
    translate: TranslateService,
    notify: SharedNotificationService,
    analytics: SharedAnalyticsService,
    resolver: ComponentFactoryResolver,
    cd: ChangeDetectorRef,
  ) {
    super(
      modalService,
      storageService,
      documentService,
      bookingService,
      shopsService,
      reviewsService,
      locationService,
      googleMapsService,
      windowService,
      route,
      translate,
      notify,
      analytics,
      resolver,
      cd,
    );
  }

  get addLuggageImageComponentType(): Type<DropOffActionComponent> {
    return DropOffActionComponent;
  }

  get explainStorageTimerActionComponentType(): Type<ExplainStorageTimerActionBaseComponent> {
    return ExplainStorageTimerActionComponent;
  }

  get leaveFeedbackActionComponentType(): Type<LeaveFeedbackActionComponent> {
    return LeaveFeedbackActionComponent;
  }

  get exploreExperiencesActionComponentType(): Type<ExploreExperiencesActionComponent> {
    return ExploreExperiencesActionComponent;
  }

  get selectPaymentMethodActionComponentType(): Type<SelectPaymentMethodActionComponent> {
    return SelectPaymentMethodActionComponent;
  }

  get undoDropOffActionComponentType(): Type<UndoDropOffActionComponent> {
    return UndoDropOffActionComponent;
  }

  get modifyBookingActionComponentType(): Type<ModifyBookingActionComponent> {
    return ModifyBookingActionComponent;
  }

  get showReceiptActionComponentType(): Type<ShowReceiptActionComponent> {
    return ShowReceiptActionComponent;
  }

  get goToShopActionComponentType(): Type<GoToShopActionComponent> {
    return GoToShopActionComponent;
  }
}
